export const CURRENCY_PRECISION = 2;